import React from 'react';
import PropTypes from 'prop-types';

import { DetailCell, ExtraIcon } from './styled';

const VehicleLateralLoadingIcon = ({ has_lateral_loading, ...props }) => (
  <DetailCell {...props}>{!!has_lateral_loading && <ExtraIcon name="side-door" />}</DetailCell>
);

VehicleLateralLoadingIcon.propTypes = {
  has_lateral_loading: PropTypes.bool,
};

export default VehicleLateralLoadingIcon;
